import { FeatureFlags } from 'models';
import { FeatureFlagHelpers } from 'helpers/FeatureFlagHelpers';

import { useCurrentTeam } from 'hooks/use-current-team';
import { useCurrentUser } from 'hooks/use-current-user';

const useCurrentUserFlag = (flag: FeatureFlags) => {
    const user = useCurrentUser();
    const team = useCurrentTeam();

    return FeatureFlagHelpers.isEnabled(flag, { user, team });
};

export { useCurrentUserFlag };
